import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

import { AnaliseService } from '../../../../../providers/analise-service';

@Component({
    selector: 'page-balanco-financeiro',
    templateUrl: 'balanco-financeiro.html',
    providers: [
        AnaliseService
    ]
})
export class ValidacaoContasTotalizadorasBalancoFinanceiroEGEPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "1522";
    codigoModulo: any;
    analise: any;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public analiseService: AnaliseService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.codigoModulo = this.navParams.get('analise').idModuloPca;
        this.analise = this.navParams.get('analise');

        this.carregarDados();
        this.setModuloId(4);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.analiseService.obterAnaliseValidacaoTotalizadorasFIN(this.idSecaoPagina).subscribe(data => {
            // if (data && data.demonstracoes && data.demonstracoes.length > 0) {
                this.listaDados = data;
                // this.listaDados.demonstracoes = data.demonstracoes.filter(d => d.origem === "BALANCO_FINANCEIRO");
            // }
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContabilidade() {
        this.menuService.redirecionarPagina(this.analiseService.obterIdPaginaContabilidade());
    }

    salvarFlagIncluir() {

        this.loading = true;

        this.listaDados.dsResultado = this.capitalize(this.listaDados.dsResultado);
        this.analiseService.salvarValidacaoContasTotalizadoras(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        });
    }

    submeterNoCertificado() {
        let idAnalise = "";

        this.loading = true;

        if (this.listaDados.dsResultado == undefined || !this.listaDados.dsResultado || this.listaDados.dsResultado.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResultado == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;
                this.listaDados.dsResultado = this.capitalize(this.listaDados.dsResultado);
                this.analiseService.submeterValidacaoContasTotalizadoras(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaContabilidade();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-financeiro-ege/balanco-financeiro.ts